"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../hooks");
var _layout = require("../../layout");
var _text = require("../../text");
var _BoxContainer = _interopRequireDefault(require("./BoxContainer"));
var _helperComponents = require("./helperComponents");
var _react2 = require("@emotion/react");
const DetailedBox = _ref => {
  let {
    children,
    details,
    isInverted: isInvertedColorScheme,
    renderTitle = _helperComponents.defaultTitleRenderer,
    titleText,
    ...boxContainerProps
  } = _ref;
  const scopedThemeProps = (0, _hooks.useScopedThemeProps)({
    isInvertedColorScheme
  });
  const hasTitle = !!titleText;
  const hasDetails = !!details;
  const renderDetails = () => typeof details === 'string' ? (0, _react2.jsx)(_text.Text, {
    variant: _text.TextVariant.BodySM
  }, details) : (0, _react2.jsx)(_layout.View, null, details);
  return (0, _react2.jsx)(_BoxContainer.default, (0, _extends2.default)({}, scopedThemeProps, boxContainerProps), (0, _react2.jsx)(_layout.Row, {
    gridGap: "S100",
    justifyContent: "space-between",
    maxWidth: "100%"
  }, hasTitle ? renderTitle({
    titleText
  }) : hasDetails && renderDetails(), children), hasDetails && hasTitle && renderDetails());
};
DetailedBox.displayName = 'DetailedBox';
var _default = exports.default = DetailedBox;